// /**时间格式化 */
import moment from "moment";
import { DATETIME_PICKER_FORMAT, DATE_PICKER_FORMAT, LOG_DATE_FORMAT } from "@supplier/constants";

export const dateFormat = (str?: string | number | Date, format: string = DATE_PICKER_FORMAT) => {
    if (!str) {
        return "";
    }
    return moment(str).format(format);
};
export const dateTimeFormat = (str?: string | number | Date, format: string = DATETIME_PICKER_FORMAT) => {
    if (!str) {
        return "";
    }
    return moment(str).format(format);
};

export const timestampToISOFormat = (str?: string | number | Date) => {
    if (!str) {
        return "";
    }
    return moment(str).format("YYYY-MM-DDTHH:mm:ss");
};
export const dateTimesFormat = (str?: string | Date, format: string = LOG_DATE_FORMAT) => {
    if (!str) {
        return;
    }
    return moment(str).format(format);
};

// 时间格式化时区加8
export const dateFormatPlusEight = (str?: string | number | Date, format: string = DATE_PICKER_FORMAT) => {
    const time = 8 * 60 * 60 * 1000;
    const currentTime = new Date(str ?? "").getTime();
    return moment(new Date(currentTime + time)).format(format);
};

export const durationFormat = (time: string) => {
    if (!time) return "";
    return timeDifferenceFormat(new Date(), new Date(time));
};

export const timeDifferenceFormat = (startTime: Date, endTime: Date) => {
    // 定义开始时间和结束时间
    const start = new Date(startTime).getTime();
    const end = new Date(endTime).getTime();
    // 计算时间差（单位：毫秒）
    const timeDiff = Math.abs(end - start);
    // 将时间差转换为天、小时和分钟
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    // 格式化时间差
    return `${days}天${hours}小时${minutes}分钟`;
};

export const timeDifferenceDayFormat = (startTime: Date, endTime: Date) => {
    // 获取开始时间和结束时间的日期部分
    const start = new Date(startTime);
    const end = new Date(endTime);

    // 计算日期差（单位：毫秒）
    const timeDiff = Math.abs(end.getTime() - start.getTime());

    // 计算天数差
    return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
};
// 获取账期截止日期距离当前日期的天数
export const getDayDifference = (settleEndDate: string) => {
    const time1 = new Date(dateFormat(settleEndDate)).getTime();
    const time2 = new Date(dateFormat(new Date())).getTime();
    // 一天的毫秒数
    const oneDay = 24 * 60 * 60 * 1000;
    // 计算两个时间戳的差值
    const diff = Math.abs(time1 - time2);
    // 将差值转换为天数
    return Math.ceil(diff / oneDay);
};
const isToday = (date: string | Date | null | undefined) => {
    if (!date) return false;
    const now = new Date();
    return (
        moment(date).year() === now.getFullYear() &&
        moment(date).month() === now.getMonth() &&
        moment(date).date() === now.getDate()
    );
};
// 判断某个时间点是否大于当前时间
export const isAfterCurrentTime = (date: string | Date | null | undefined) => {
    if (!date) return false;
    const now = new Date();
    return moment(date).isAfter(now);
};

export const onDisabledDate = (date: Date) => {
    const current = Date.now();
    const time = new Date(date).getTime();
    return time > current;
};
export const onDisableHours = (selectDate: string) => {
    const hours: number[] = [];
    const now = new Date();
    const currentHour = now.getHours();
    if (isToday(selectDate)) {
        for (let i = currentHour + 1; i < 24; i++) {
            hours.push(i);
        }
    }
    return hours;
};
export const onDisableMinutes = (selectDate: string, selectedHour: number) => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    if (selectedHour === currentHour && isToday(selectDate)) {
        const minutes: number[] = [];
        for (let i = currentMinute + 1; i < 60; i++) {
            minutes.push(i);
        }
        return minutes;
    }
    return [];
};
/**
 *
 * 时间校验
 */
export const dateValidator = ({ min, max, msg }: { min?: boolean; max?: boolean; msg: string }) => {
    return (_rule: unknown, value: string, callback: (msg?: string) => void) => {
        const valueTime = new Date(value).getTime();
        if (min || max) {
            if (min && new Date(dateFormat(new Date(), DATETIME_PICKER_FORMAT)).getTime() > valueTime) {
                callback(msg);
            }
            if (max && new Date(dateFormat(new Date(), "YYYY-MM-DD HH:mm:59")).getTime() < valueTime) {
                callback(msg);
            }
        }
        callback();
    };
};
